"use client"
import React from "react";
import { motion } from "motion/react";
import Portfolio from "./Portfolio";

export default function SyncnotesPage() {
  return (
    <div>
      <motion.div
        className="min-h-screen min-w-full relative block dark:hidden"
        initial={{
          background: "linear-gradient(to top, #fff,#9AA3D5)",
        }}
        whileInView={{
          background: "linear-gradient(to top, #fff, #B3A1CF)",
          transition: {
            duration: 3,
            ease: "easeInOut",
            repeat: Infinity,
            repeatType: "reverse",
          },
        }}
      >
        <Portfolio />
      </motion.div>
      <motion.div
        className="min-h-screen min-w-full relative hidden dark:block"
        initial={{
          background: "linear-gradient(to top, #00000b,#5261B7)",
        }}
        whileInView={{
          background: "linear-gradient(to top, #00000b, #7B5DAC)",
          transition: {
            duration: 3,
            ease: "easeInOut",
            repeat: Infinity,
            repeatType: "reverse",
          },
        }}
      >
        <Portfolio />
      </motion.div>
    </div>
  );
}
